import { render, staticRenderFns } from "./InputInboxApproval.vue?vue&type=template&id=5635b1c4&scoped=true&"
import script from "./InputInboxApproval.vue?vue&type=script&lang=js&"
export * from "./InputInboxApproval.vue?vue&type=script&lang=js&"
import style0 from "./InputInboxApproval.vue?vue&type=style&index=0&id=5635b1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635b1c4",
  null
  
)

export default component.exports